import { atom } from 'jotai';

import { productsState } from './products.state';

export const hasSelectedProductsAtom = atom<boolean>((get) => {
  const products = get(productsState);
  return products.some((p) => p.activeVersion.isSelected);
});
